export const calculatorValues = new Map([
  [250, 470925],
  [500, 941850],
  [1000, 2511600],
  [2000, 5023200],
  [4000, 10046400],
  [6000, 18837000],
  [8000, 25116000],
  [10000, 31395000],
  [12000, 37674000],
  [14000, 43953000],
  [16000, 50232000],
  [18000, 56511000],
  [20000, 62790000],
])
